import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'unh-simple-card',
  templateUrl: './simple-card.component.html',
  styleUrls: ['./simple-card.component.scss']
})
export class SimpleCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
